import { fromJS } from 'immutable';
import { get } from 'lodash';

import {
  SET_LAWYER_REJECTED_CLAIMS,
  SET_SEARCH_REJECTED_CLAIMS,
} from 'containers/RejectedClaimsPage/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';

const initialState: any = fromJS({
  claims: [],
  countClaims: 0,
});

const lawyerRejectedClaimsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_LAWYER_REJECTED_CLAIMS:
      return state
        .set('claims', fromJS(get(action.response, 'claims', [])))
        .set('countClaims', fromJS(get(action.response, 'total', 0)));
    case SET_SEARCH_REJECTED_CLAIMS:
      return state
        .set('claims', fromJS(action.data))
        .set('countClaims', fromJS(get(action, 'data', []).length));
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default lawyerRejectedClaimsReducer;
